import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import { CustomerData } from "@/hooks/useAccountValidation";

interface CustomerDataDisplayProps {
  customerData: CustomerData;
}

const CustomerDataDisplay: React.FC<CustomerDataDisplayProps> = ({
  customerData,
}) => {
  const { ratePlan, careEligible, feraEligible, cocEligible, address, city } =
    customerData;

  return (
    <Box
      sx={{
        backgroundColor: "success.light",
        border: "1px solid",
        borderColor: "success.main",
        borderRadius: "8px",
        padding: "12px",
        marginTop: "8px",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          marginBottom: "8px",
          color: "success.dark",
        }}
      >
        Customer Information Retrieved
      </Typography>

      {address && (
        <Box sx={{ marginBottom: "8px" }}>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            Address:
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {address}
          </Typography>
        </Box>
      )}

      {city && (
        <Box sx={{ marginBottom: "8px" }}>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            City:
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {city}
          </Typography>
        </Box>
      )}

      {ratePlan && (
        <Box sx={{ marginBottom: "8px" }}>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            Rate Plan:
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {ratePlan}
          </Typography>
        </Box>
      )}

      <Box sx={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
        {careEligible && (
          <Chip
            label="CARE Eligible"
            size="small"
            sx={{
              backgroundColor: "primary.light",
              color: "primary.contrastText",
              fontSize: "11px",
            }}
          />
        )}
        {feraEligible && (
          <Chip
            label="FERA Eligible"
            size="small"
            sx={{
              backgroundColor: "secondary.light",
              color: "secondary.contrastText",
              fontSize: "11px",
            }}
          />
        )}
        {cocEligible && (
          <Chip
            label="CoC Eligible"
            size="small"
            sx={{
              backgroundColor: "warning.light",
              color: "warning.contrastText",
              fontSize: "11px",
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default CustomerDataDisplay;
